'use client';

import { BlockResolverProvider } from '@akademi/site-builder-runtime';
import type { ComposedTreeNode } from '@/src/lib/server/sitebuilder';
import { storefrontBlockResolver } from './blockResolver';
import { ComposedTreeRenderer } from './ComposedTreeRenderer';

/**
 * Client boundary for a composed tree: mounts the resolver context (React
 * context is client-only) and walks the tree. Kept separate so the page and
 * shell mounts above it stay Server Components.
 */
export function StorefrontTreeClient({
  tree,
  themeId,
  locale,
  fallbackLocale,
}: {
  tree: ComposedTreeNode;
  themeId?: string | null;
  locale: string;
  fallbackLocale: string;
}) {
  return (
    <BlockResolverProvider value={storefrontBlockResolver}>
      <ComposedTreeRenderer
        tree={tree}
        themeId={themeId}
        locale={locale}
        fallbackLocale={fallbackLocale}
      />
    </BlockResolverProvider>
  );
}
